import {
  Component,
} from 'ng-metadata/core';

import passportSelectHtml from './passport-select.html';
import './passport-select.scss';

/**
 * Simple component containing a dropdown that routes to
 * a passport product page on select.
 */
@Component({
  selector: 'gw-passport-select',
  template: passportSelectHtml,
})
export class PassportSelectComponent {
  public GW = (<any>window).GW;
  public laroute = (<any>window).laroute;
  public passportType: string;
  public passportProducts = this.GW.passportProducts;

  goToProduct() {
    const route = this.laroute.route('checkout.options', {
      product: this.passportType,
    });

    window.location.assign(route);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/passport-select/passport-select.component.ts